/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { resolveNativeEmbedInitialLayout } from '@atlaskit/native-embeds-common/initial-layout';

const placeholderStyles = css({
	boxSizing: 'border-box',
	maxWidth: '100%',
	overflow: 'hidden',
	borderStyle: 'solid',
	borderWidth: token('border.width'),
	borderColor: token('color.border'),
	borderRadius: token('radius.xlarge'),
});

export const NativeEmbedSsrPlaceholder = ({ extension }: { extension: any }): JSX.Element => {
	const macroId = extension?.parameters?.macroMetadata?.macroId?.value;
	const { effectiveHeight, effectiveWidth, lockAspectRatio, placeholderId } =
		resolveNativeEmbedInitialLayout({
			parameters: extension?.parameters,
			placeholderId: macroId ? `native-embed-${macroId}` : undefined,
		});

	return (
		<div
			css={placeholderStyles}
			data-testid="native-embed-ssr-placeholder"
			{...(placeholderId && { 'data-ssr-placeholder': placeholderId })}
			/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- width/height/aspectRatio are dynamic macro params that cannot be expressed as static CSS */
			style={{
				width: effectiveWidth ? `${effectiveWidth}px` : '100%',
				height: lockAspectRatio ? 'auto' : `${effectiveHeight}px`,
				aspectRatio: lockAspectRatio
					? effectiveWidth && effectiveHeight
						? `${effectiveWidth} / ${effectiveHeight}`
						: '760 / 600'
					: undefined,
			}}
			/* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */
		/>
	);
};
